import { render } from "./Table.vue?vue&type=template&id=2f5d1c71"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yuhuiliu/code/btkcode/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__